import { render, staticRenderFns } from "./WorkScheduleDetails.vue?vue&type=template&id=993d54c0&scoped=true"
import script from "./WorkScheduleDetails.vue?vue&type=script&lang=js"
export * from "./WorkScheduleDetails.vue?vue&type=script&lang=js"
import style0 from "./WorkScheduleDetails.vue?vue&type=style&index=0&id=993d54c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993d54c0",
  null
  
)

export default component.exports